import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userinfo: null,
    aside: {
        openKeys: [],
        selectedKeys: [],
        menuData: []
    },
    organizationData: [],
    campusInfo: null
  },
  mutations: {
    changeState(state, { name, value }) {
      state[name] = value;
    }
  },
  actions: {
  },
  modules: {
  }
})
